import React from "react";
import { useFormContext, useFieldArray, Controller } from "react-hook-form";
import { Form, Card, Row, Col, Image } from "react-bootstrap";
import TextInput from "components/TextInput";
import IMAGES from "constants/images";
import { stripHtmlTags } from "utils/helpers";

const PricingFeatureForm = ({
  control,
  register,
  setValue,
  errors,
  getValues,
}) => {
  // Features array
  console.log("values", getValues());
  const {
    fields: features,
    append: appendFeature,
    update: updateFeature,
    remove: removeFeature,
  } = useFieldArray({
    control,
    name: "features",
  });

  // Pricing plans array
  const {
    fields: pricing,
    append: appendPricing,
    update: updatePricing,
    remove: removePricing,
  } = useFieldArray({
    control,
    name: "pricing",
  });

  console.log('errors', errors)

  const PricingFeatures = ({ planIndex, control, register, setValue }) => {
    const { fields, append, remove } = useFieldArray({
      control,
      name: `pricing.${planIndex}.features`,
    });

    return (
      <> 
        {fields.map((field, featureIndex) => (
        <>
        <label htmlFor={`pricing.${planIndex}.features.${featureIndex}.value`} className="mb-2">Feature {featureIndex+1}</label>
          <div key={field.id} className="d-flex align-items-center gap-2 mb-2">
            <input
              className="form-control"
              type="text"
              placeholder={`Enter plan feature ${featureIndex+1}`}
              {...register(
                `pricing.${planIndex}.features.${featureIndex}.value`
              )}
              defaultValue={field.value || ""}
            />
          
            {featureIndex === fields.length - 1 ? (
              <img
                src={IMAGES.AddBigPlus_IMG}
                className="cursor-pointer"
                onClick={() => append({ value: "" })}
                alt="Add Feature"
              />
            ) : (
              <img
                src={IMAGES.Minus_IMG}
                className="cursor-pointer"
                onClick={() => remove(featureIndex)}
                alt="Remove Feature"
              />
            )}
          </div>
            {errors.pricing?.[planIndex]?.features?.[featureIndex]?.value && (
              <p className="text-danger ms-2">{errors.pricing?.[planIndex]?.features?.[featureIndex]?.value?.message}</p>
            )}
          </>
        ))}
      </>
    );
  };

  const Features = ({ planIndex, control, register, setValue }) => {
    const { fields, append, remove } = useFieldArray({
      control,
      name: `features.${planIndex}.descriptions`,
    });

    return (
      <>
        {fields.map((field, featureIndex) => (
        <>
            <label htmlFor={`features.${planIndex}.descriptions.${featureIndex}.value`} className="mb-2">Description {featureIndex+1}</label>

          <div key={field.id} className="d-flex align-items-center gap-2 mb-2">
            <input
              className="form-control"
              type="text"
              placeholder={`Enter feature description ${featureIndex+1}`}
              {...register(
                `features.${planIndex}.descriptions.${featureIndex}.value`
              )}
              defaultValue={field.value || ""}
            />
         

            {featureIndex === fields.length - 1 ? (
              <img
                src={IMAGES.AddBigPlus_IMG}
                className="cursor-pointer"
                onClick={() => append({ value: "" })}
                alt="Add Feature"
              />
            ) : (
              <img
                src={IMAGES.Minus_IMG}
                className="cursor-pointer"
                onClick={() => remove(featureIndex)}
                alt="Remove Feature"
              />
            )}
          </div>
             {errors.features?.[planIndex]?.descriptions?.[featureIndex]?.value && (
              <p className="text-danger ms-2">{errors.features?.[planIndex]?.descriptions?.[featureIndex]?.value?.message}</p>
            )}
          </>
        ))}
      </>
    );
  };
  console.log("pricing", pricing);

  return (
    <Col lg={12} className="product__form">
         <Col md={12} style={{ margin: "40px 0px" }}>
        <hr className="my-4" />
      </Col>
      {/* Features Section */}
      <div className="form__Label mb-4 d-flex align-items-center justify-content-between">
        <h4>Features</h4>
        <Image
          src={IMAGES.AddBigPlus_IMG}
          className="cursor-pointer"
          onClick={() => appendFeature({ title: "", descriptions: [{value: ""}] })}
          alt="Add Feature"
        />
      </div>

      {features?.map((feature, index) => (
        <Card className="mb-3" key={feature.id}>
          <Card.Body>
            <div className="d-flex justify-content-between align-items-center mb-2">
              <h5>Feature {index + 1}</h5>
              {index > 0 && (
                <Image
                  src={IMAGES.Minus_IMG}
                  className="cursor-pointer"
                  onClick={() => removeFeature(index)}
                  alt="Remove Feature"
                />
              )}
            </div>
            <TextInput
              labelText="Title"
              type="text"
              placeholder={`Enter feature title `}
              {...register(`features.${index}.title`, { required: true })}
              defaultValue={feature.title}
              
            />
            {errors.features?.[index]?.title && (
              <p className="text-danger">{errors.features?.[index]?.title?.message}</p>
            )}
            {/* <TextInput
              labelText="Description"
              type="text"
              textarea="textarea"
              rows={6}
              {...register(`features.${index}.description`, {
                setValueAs: (v) =>
                  typeof v === "string" ? v.split(",").map((s) => s.trim()) : v,
              })}

defaultValue={Array.isArray(feature?.description)
  ? feature.description.join(", ")
  : stripHtmlTags(feature?.description)}
              // defaultValue={feature?.description?.join(", ")}
            /> */}
             <Features
                planIndex={index}
                control={control}
                register={register}
                setValue={setValue}
              />
          </Card.Body>
        </Card>
      ))}
   <Col md={12} style={{ margin: "40px 0px" }}>
        <hr className="my-4" />
      </Col>
      {/* Pricing Section */}
      <div className="form__Label mb-4 d-flex align-items-center justify-content-between">
        <h4>Pricing</h4>
        <Image
          src={IMAGES.AddBigPlus_IMG}
          className="cursor-pointer"
          onClick={() =>
            appendPricing({
              name: "",
              price: 0,
              seats: 0,
              description: "",
              features: [{ value: "" }],
            })
          }
          alt="Add Pricing Plan"
        />
      </div>

      {pricing?.map((plan, planIndex) => {
        return (
          <Card className="mb-3" key={plan.id}>
            <Card.Body>
              <div className="d-flex justify-content-between align-items-center mb-2">
                <h5>Pricing Plan {planIndex + 1}</h5>
                {planIndex > 0 && (
                  <Image
                    src={IMAGES.Minus_IMG}
                    className="cursor-pointer"
                    onClick={() => removePricing(planIndex)}
                    alt="Remove Pricing Plan"
                  />
                )}
              </div>
              <Row>
                <Col md={4}>
                  <TextInput
                    labelText="Name"
                    type="text"
                      placeholder="Enter plan name"
                    {...register(`pricing.${planIndex}.name`, {
                      required: true,
                    })}
                    defaultValue={plan.name}
                  />
                  {errors?.pricing?.[planIndex]?.name && (
                    <p className="text-danger">
                      {errors.pricing?.[planIndex]?.name?.message?.replace(/pricing\[\d+\]\.name/, 'Name')}
                    </p>
                  )}
                </Col>
                <Col md={4}>
                  <TextInput
                    labelText="Price"
                      placeholder="Enter price"
                    type="number"
                    {...register(`pricing.${planIndex}.price`, {
                      required: true,
                      valueAsNumber: true,
                    })}
                    onKeyDown={(e) => {
                      if (["-", "e", "E", "+"].includes(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    onChange={(e) => {
                      let value = e.target.value;

                      // Remove leading zeros (but preserve "0." for decimals)
                      // value = value.replace(/^0+(?!\.)/, "");

                      // Restrict to 2 decimal places
                      if (value.includes(".")) {
                        const [intPart, decimalPart] = value.split(".");
                        value = intPart + "." + decimalPart.slice(0, 2);
                      }

                      e.target.value = value;
                    }}
                    defaultValue={plan.price}
                  />
                  {errors?.pricing?.[planIndex]?.price && (
                    <p className="text-danger">{errors.pricing?.[planIndex]?.price?.message}</p>
                  )}
                </Col>
                <Col md={4}>
                  <TextInput
                    placeholder="Enter no of seats"
                    labelText="No of Seats"
                    type="number"
                    {...register(`pricing.${planIndex}.seats`, {
                      required: true,
                      valueAsNumber: true,
                      min: 1,
                    })}
                    onKeyDown={(e) => {
                      if (["-", "e", "E", "+"].includes(e.key)) {
                        e.preventDefault();
                      }
                    }}
                   
                    defaultValue={plan.seats}
                  />
                  {errors?.pricing?.[planIndex]?.seats && (
                    <p className="text-danger">{errors.pricing?.[planIndex]?.seats?.message}</p>
                  )}
                </Col>
              </Row>

              <TextInput
                labelText="Description"
                type="text"
                placeholder="Enter description"
                textarea="textarea"
                rows={3}
                {...register(`pricing.${planIndex}.description`)}
                defaultValue={plan.description}
              />
              {errors?.pricing?.[planIndex]?.description && (
                <p className="text-danger">{errors.pricing?.[planIndex]?.description?.message}</p>
              )}
              <div className="form__Label mt-4 mb-2 d-flex align-items-center justify-content-between">
                <div className="form__Label mt-4 mb-2">
                  <h4>Features </h4>
                </div>
              </div>
              <PricingFeatures
                planIndex={planIndex}
                control={control}
                register={register}
                setValue={setValue}
              />
            </Card.Body>
          </Card>
        );
      })}
    </Col>
  );
};

export default PricingFeatureForm;
